import translate from '@translate';
import React, { FC } from 'react';
import Grid, { GridItem } from 'src/components/Grid';
import TextField from 'src/components/TextField';
import { BillOfMaterialsType } from 'src/types/billOfMaterials';
import ProductsSelect from 'src/components/ProductsSelect';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './constants';

export interface DetailPropsType {
    onChange: OnChangeType<EditKeysType>;
    editData: BillOfMaterialsType;
    editErrors: FormErrorsType;
    newBillsOfMaterials: boolean;
    disableEdit: boolean;
}

const Detail: FC<DetailPropsType> = (props) => {
    return (
        <Grid>
            <GridItem cols={6}>
                <TextField
                    value={props.editData.NAME}
                    error={props.editErrors.NAME}
                    onChange={(value, error) => props.onChange('NAME', value, error)}
                    name="NAME"
                    label={translate('billOfMaterialsDetail.name')}
                    fullWidth
                    required
                    disabled={props.disableEdit}
                />
            </GridItem>
            <GridItem cols={6}>
                <ProductsSelect
                    idKey="ID"
                    value={props.editData.ID_FINAL_PRODUCT}
                    error={props.editErrors.ID_FINAL_PRODUCT}
                    onChange={(value, error) => {
                        if (!Array.isArray(value)) {
                            props.onChange('ID_FINAL_PRODUCT', value.ID, error);
                        }
                    }}
                    name="ID_FINAL_PRODUCT"
                    label={translate('billOfMaterialsDetail.finalProduct')}
                    fullWidth
                    required
                    disabled={props.disableEdit}
                />
            </GridItem>
        </Grid>
    );
};

export default Detail;
